// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sJ_t","col":"styles_col__3qcM5"};